import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { PlateTypeEnum } from '../../../../../models/cutting/cutting-panel-outline.model';

@Component({
  selector: 'csl-groove-plate-selector',
  templateUrl: './groove-plate-selector.component.html',
})
export class GroovePlateSelectorComponent implements OnInit {
  thisPlateTypeEnum = PlateTypeEnum;

  @Input() disabled = false;
  @Input() plate: PlateTypeEnum;
  @Output() plateChange: EventEmitter<PlateTypeEnum> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}
}
